import { Link } from "react-router-dom";

/**
 * UserLink — turns any username display into a Link to /app/u/:username
 *
 * Props:
 *   - username: the target username (required; renders plain children if missing)
 *   - children: the label to render (e.g. "@alice", full name, avatar block)
 *   - className: extra classes for the anchor
 *   - stopPropagation: prevent the click from bubbling to parent handlers (default true)
 *   - testId: optional data-testid
 */
export default function UserLink({
  username,
  children,
  className = "",
  stopPropagation = true,
  testId,
}) {
  if (!username) return <>{children}</>;
  const uname = String(username).replace(/^@/, "");
  return (
    <Link
      to={`/app/u/${uname}`}
      data-testid={testId || `user-link-${uname}`}
      onClick={(e) => { if (stopPropagation) e.stopPropagation(); }}
      className={`hover:text-[#FFD700] transition-colors ${className}`}
    >
      {children}
    </Link>
  );
}
